/**
 *@desc: 异步请求
 *@author: XinD
 *@date: 2021/11/4
 */
import Request from "./request";
import config from "@/config";

const Axios = new Request(config.baseURL);
export const AxiosAdmin = new Request(config.adminUrl);
export default Axios;

export const AxiosSilent = new Request(config.baseURL, { noToast: true });
